// Custom hook for Services
import { useSelector, useDispatch } from 'react-redux';
import {
    fetchSubCategories,
    createSubCategory,
    selectSubCategories,
    selectSubCategoriesError,
    selectSubCategoriesLoading,
    deleteSubCategory,
    toggleSubCategoryStatus,
    updateSubCategory,
} from '../store/slices/subCategorySlice';

export const useSubCategories = () => {
    const dispatch = useDispatch();
    const subCategories = useSelector(selectSubCategories);
    const loading = useSelector(selectSubCategoriesLoading);
    const error = useSelector(selectSubCategoriesError);

    return {
        // State
        subCategories,
        loading,
        error,
        // Actions
        fetchSubCategories: (id) => dispatch(fetchSubCategories(id)),
        deleteSubCategory: (id) => dispatch(deleteSubCategory(id)).unwrap(),
        createSubCategory: (payload) => dispatch(createSubCategory(payload)).unwrap(),
        updateSubCategory: (id, data) => dispatch(updateSubCategory({ id, data })).unwrap(),
        toggleSubCategoryStatus: (id, isActive) => dispatch(toggleSubCategoryStatus({ id, isActive })).unwrap(),
    };
};